import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import LoadingScreen from "../../components/elements/LoadingScreen";
import PageHeader from "../../components/elements/PageHeader";
import ReleaseService from "../../services/release.service";
import ReleaseEmailSetting from "../AccountSettings/ReleaseEmailSetting";

import "./styles.scss";

const GROUPS = [
  { key: "new", label: "New" },
  { key: "improved", label: "Improved" },
  { key: "fixed", label: "Fixed" },
];

export const WhatsNew = () => {
  const [releases, setReleases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    ReleaseService.getReleases()
      .then((data) => {
        setReleases(data);
        // Only mark as seen once the notes are actually on screen; a failure here is harmless.
        ReleaseService.markSeen().catch(() => {});
      })
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div style={{ width: "100%" }}>
      <LoadingScreen isActive={loading} />
      <PageHeader pageName="Release Notes" />
                {/* <ReleaseEmailSetting /> */}

      <div className="whats-new">
        {error && <p>Release notes couldn't be loaded. Refresh the page to try again.</p>}
        {!loading && !error && releases.length === 0 && <p>No release notes yet.</p>}

        {releases.map((release) => (
          <section key={release.version} className="whats-new-release">
            <div className="whats-new-release-header">
              <h3>
                {release.version}
                {release.is_new && <span className="whats-new-new-tag">New</span>}
              </h3>
              <span>{dayjs(release.release_date).format("D MMM YYYY")}</span>
            </div>

            {GROUPS.map(({ key, label }) => {
              const items = release.items.filter((item) => item.group === key);
              if (items.length === 0) return null;

              return (
                <div key={key} className="whats-new-group">
                  <h4>{label}</h4>
                  <ul>
                    {items.map((item, index) => (
                      <li key={index}>{item.text}</li>
                    ))}
                  </ul>
                </div>
              );
            })}
          </section>
        ))}
      </div>
    </div>
  );
};
